import { withIconWrapper } from 'hocs/withIconWrapper';

import { ReactComponent } from './ChevronLeft24Icon.c.svg';

export const ChevronLeft24Icon = withIconWrapper(ReactComponent);
